import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateActivityTemplateMutation as CreateActivityTemplateMutationType,
  CreateActivityTemplateMutationVariables,
} from "./__generated__/CreateActivityTemplateMutation";

const CreateActivityTemplateMutation = loader("./CreateActivityTemplateMutation.gql");

type CreateActivityTemplateMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateActivityTemplateMutationType) => void;
}) => ReactElement;

export const CreateActivityTemplateMutationProvider: CreateActivityTemplateMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<
    CreateActivityTemplateMutationType,
    CreateActivityTemplateMutationVariables
  >(CreateActivityTemplateMutation, {
    errorPolicy: "none",
    onError,
    onCompleted,
  });

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
